/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.smartCenter {
  angular.module("meevo.plugins.smartCenter", []);
}
